import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, searchBy } from "./Column.js";
import BasicTable from "../../../components/Table/BasicTable.jsx";
import { useFetchAll } from "../../../custom/FetchApiHook.jsx";
import AddGIR from "./AddStockOnHandReport.jsx";
import BreadCrumb from "../../../components/BreadCrumb.jsx";
import AddStockOnHandReport from "./AddStockOnHandReport.jsx";
import { InventoryApi } from "../../../apis/inventory.api.js";

const StockOnHandReport = ({ disabledFilters }) => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const handlePagination = (data) => {
    console.log(data);

    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };
      // copyfilter[]

      if (data.filter) {
        // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
        // console.log("Object.keys[copyfilter]",Object.keys(data.filter))

        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  // const { value, fetchAllData } = useFetchAll(() => RolePermissionApi.getAllRolePermissions(pagination,search));

  const [selectedCell, setSelectedCell] = useState(null);
  const [ModalOpen, setModalOpen] = useState(false);
  const [editRolePermissions, setEditRolePermissions] = useState(null);

  const [allStockOHReport, setSOHReport] = useState(null);
  //   const [isArticleOpen, setIsArticleOpen] = useState(false);
  //   const [description, setDescription] = useState(null);

  const getAllSOHR = async () => {
    try {
      const res = await InventoryApi.getAllOnHandReport(pagination, search);
      console.log("res", res);
      setSOHReport(res?.data?.data);
    } catch (error) {
      console.log("Erorr", error);
    }
  };

  const closeRoleModal = () => {
    setModalOpen(false);
    setEditRolePermissions(null);
  };

  const handleRowClick = (row) => {
    setSelectedCell(row);
    setModalOpen(true);
  };

  const handleCellClick = (cell, field = "") => {
    if (field === "roleId") {
      setEditRolePermissions(cell);
      setModalOpen(true);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    setSearch("");
    handlePagination && handlePagination(clearPagination);
  };

  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }
    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllSOHR();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BreadCrumb title={"Stock On Hand Report"} />
      <BasicTable
        columns={columns}
        // data={value?.data?.allRolePermission || []}
        data={[]}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: 1, // value?.data?.page ||
          rows: 5, // value?.data?.limit ||
          sortField: null,
          sortOrder: null,
          totalPages: 1, // value?.data?.totalPages ||
          totalCount: 1, // value?.data?.totalCount ||
        }}
        onCellClick={(e) => console.log("Cell Data", e)}
        handleSearch={debouncedSearch}
        SearchBy={searchBy}
        handleFilter={handleFilter}
        handleClearFilter={handleClearFilter}
        selectedData={selectedCell}
        handleCellClick={handleCellClick}
        // button_name="Add Stock On Hand Report"
        handleButton={() => {
          setModalOpen(true);
        }}
      />
      {/* <AddStockOnHandReport
        // getAllData={fetchAllData}
        currentItems={editRolePermissions}
        open={ModalOpen}
        handleClose={closeRoleModal}
      /> */}
    </div>
  );
};

export default StockOnHandReport;
